import React, { useEffect } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import GridTable from "../Common/GridTable";
import { useNavigate } from "react-router-dom";
import { ColDef } from "@material-ui/data-grid";
import { setResponseMessage } from "features/admin/adminSlice";
import { deleteMeta, fetchAllMetas, selectAllMetas, selectLoading } from "features/admin/Meta/metasAdminSlice";
interface AllMetasTableProps {}
const columns: ColDef[] = [{ sortable: false, field: "alias", headerName: "Alias", width: 300 }];

const MetasTable: React.FC<AllMetasTableProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const Metas = useSelector(selectAllMetas);
  const isLoading = useSelector(selectLoading);
  useEffect(() => {
    dispatch(fetchAllMetas());
  }, [dispatch]);

  const add = () => {
    navigate("/metas/add");
  };
  const refresh = () => {
    dispatch(fetchAllMetas());
  };
  const remove = (ids: string[]) => {
    ids.forEach((id: string) => {
      const _refId = Metas.find((item: { id: number }) => item.id === parseInt(id))?.refId;
      _refId &&
        batch(() => {
          dispatch(setResponseMessage({ message: "", hasError: false }));
          dispatch(deleteMeta(_refId));
        });
    });
    dispatch(fetchAllMetas());
  };
  const edit = (id: string) => {
    const _refId = Metas.find((item: { id: number }) => item.id === parseInt(id))?.refId;
    _refId && navigate(`/metas/edit/${_refId}`);
  };

  return (
    <GridTable
      add={add}
      refresh={refresh}
      remove={remove}
      edit={edit}
      data={Metas}
      columns={columns}
      isLoading={isLoading}
      searchProperty="title"
    />
  );
};

export default MetasTable;
